<template>
  <header class="header a-main-content">
    <nav class="header-navbar navbar navbar-expand-lg">
      <div class="navbar-brand-block">
        <a class="navbar-brand" href="/"><img src="@/assets/img/static/logo-new.svg" alt=""></a>
        <!--<img class="navbar-brand-minsk" src="@/assets/img/static/minsk.svg" alt="minsk.2019">-->
      </div>

      <button class="navbar-toggler"
              :class="{'collapsed': isCollapsed}"
              @click.prevent="onTogglerClick">
        <span class="navbar-toggler-icon"></span>
        <span class="navbar-toggler-icon"></span>
        <span class="navbar-toggler-icon"></span>
      </button>

      <div ref="header"
           class="header-collapse collapse navbar-collapse"
           :class="{'show': !isCollapsed}">
        <div class="header-current-date-block">
          <p class="header-current-date">
            <span>{{ serverDateTime | moment('timezone', 'Europe/Minsk', 'ddd')}}</span>, {{ serverDateTime | moment('timezone', 'Europe/Minsk', 'DD MMM')}}
          </p>
          <span class="header-span-date">|</span>
          <p class="header-current-time">{{ serverDateTime | moment('timezone', 'Europe/Minsk', 'HH:mm:ss')}} {{$t('minsk')}}</p>
        </div>
        <ul class="navbar-nav header-navbar-nav-ul">
          <li class="nav-item nav-item-auth" v-if="!hasAccess">
            <popover popover-class="a-login-form">
              <a class="nav-link nav-link--auth" href="#" v-t="'sign-in-link'"></a>

              <template slot="popover">
                <signin-form></signin-form>
              </template>
            </popover>
          </li>
          <li class="nav-item nav-item-login" v-if="hasAccess">
            <span class="nav-link nav-item-login__link">{{user | fullName}}</span>
            <p class="nav-item-login__text" v-t="state.label"></p>
          </li>
          <li class="nav-item" v-if="hasAccess">
            <popover ref="popover" :disabled="nbOfNotifications == 0">
              <span class="nav-link" >
                <div class="badge badge-pill badge-danger" v-if="nbOfNotifications">{{nbOfNotifications}}</div>
                <img src="@/assets/img/static/b-icon_bell.svg" alt="">
              </span>

              <template slot="popover">
                <div style="width: 410px; max-height: 500px; overflow-y: auto">
                  <notifications :items="notifications" @close="$refs.popover.hide()"></notifications>
                </div>
              </template>
            </popover>
          </li>
          <li class="nav-item nav-item-auth" v-if="hasAccess">
            <a class="nav-link nav-link--auth" href="#" v-t="'sign-out-link'" @click.prevent="onSignoutClick"></a>
          </li>
          <li class="nav-item" v-if="!hasAccess">
            <router-link to="/signup" v-t="'registration-link'" class="nav-link"/>
          </li>
          <li class="nav-item">
            <a class="nav-link" :href="config.links.regulations" v-t="'regulations-link'"></a>
          </li>
          <language-selector></language-selector>
        </ul>

      </div>
    </nav>
  </header>
</template>

<script>
  import _ from 'lodash'
  import LanguageSelector from './LanguageSelector'
  import UserState from '@/api/types/user-state'
  import SigninForm from './signin/SigninForm'
  import Tooltip from '@/widgets/tooltip'
  import Notifications from '@/components/notifications/Notifications'
  import Popover from '@/widgets/popover'

  export default {
    components: {
      LanguageSelector,
      SigninForm,
      Tooltip,
      Notifications,
      Popover
    },

    created() {
      setInterval(() => {
        this.serverDateTime = new Date;
      }, 1000)
    },

    computed: {
      hasAccess() {
        return this.$store.state.auth.isAuthorized;
      },

      user() {
        return this.$store.getters.currentUser;
      },

      accreditation() {
        return this.$store.getters.currentAccreditation;
      },

      notifications() {
        return this.$store.getters.notifications;
      },

      nbOfNotifications() {
        return _.get(this.notifications, 'length');
      },

      state() {
        let state;

        if (!state && this.user.permissions.CAN_USE_ACCREDITATION && this.accreditation && this.accreditation.state.APPROVED) {
          state =  new UserState(UserState.APPROVED);
        }

        if (!state && this.user.permissions.CAN_ADD_DIGITAL_SIGNATURE) {
          const approvedSignature = _.find(this.user.signatures, s => s.state.APPROVED);

          if (approvedSignature) {
            state = new UserState(UserState.APPROVED);
          }
        }

        if (!state) {
          state = new UserState(UserState.ACTIVE);
        }

        return state;
      }
    },
    data: () => ({
      serverDateTime: new Date,
      isCollapsed: true
    }),
    methods: {
      onSignoutClick() {
        this.$store.dispatch('logout');
      },

      onTogglerClick() {
        this.isCollapsed = !this.isCollapsed;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .nav-item-login {
    margin-right: 0px;

    &:before {
      background-image: none! important;
    }
  }

  .nav-item-auth {
    margin-left: 20px;
  }

  .badge {
    float: right;
    right: 10px;
    top: 0px;
    position: relative;
  }
</style>
